<div class="row" style="margin-bottom: 15px;">
    <div class="col-4" style="display: table;">
        <div style="display:table-cell; vertical-align:middle; text-align: right;">
            Filter taxonomy nodes
        </div>
    </div>
    <div class="col-8" style="display: table;">
        <div style="display: table-cell; vertical-align: middle;">
            <app-search-box searchBoxName="filter" [search]="filter"></app-search-box>
        </div>
    </div>
</div>
<br><br>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <!-- use a disabled button to provide padding for tree leaf -->
        <button mat-icon-button disabled></button>
        <span [class]="node.id == selectedNodeId ? 'iab-node-selected' : 'iab-node-unselected'"
            (click)="selectNode(node)">{{node.description}}</span>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <span [class]="node.id == selectedNodeId ? 'iab-node-selected' : 'iab-node-unselected'"
            (click)="selectNode(node)">{{node.description}}</span>
    </mat-tree-node>
</mat-tree>

